var $94ea096d46664c2a$exports = {};
$94ea096d46664c2a$exports = {
    "removeButtonLabel": `Pa\u{161}alinti`,
    "removeDescription": `Nor\u{117}dami pa\u{161}alinti \u{17E}ym\u{105}, paspauskite \u{201E}Delete\u{201C} klavi\u{161}\u{105}.`
};


export {$94ea096d46664c2a$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
